// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"441":"82608bdc67fb406b","591":"7cee6ea506adc1bf","848":"1167b0b8d3f03885"}[chunkId] + ".js";
};